// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"5e918190","506":"b8582b57","575":"281ac13e","649":"97721671","763":"89536d62","822":"80325c60","896":"8cc2767a","941":"1052a047","969":"dbefd108"}[chunkId] + ".chunk.js";
};